import { render, staticRenderFns } from "./ManagePermissions.vue?vue&type=template&id=3b7b2a41&scoped=true"
import script from "./ManagePermissions.vue?vue&type=script&lang=js"
export * from "./ManagePermissions.vue?vue&type=script&lang=js"
import style0 from "./ManagePermissions.vue?vue&type=style&index=0&id=3b7b2a41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7b2a41",
  null
  
)

export default component.exports